// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"080b5ff6","162":"7b469df1","171":"1267ec42","400":"ec526f0c"}[chunkId] + ".chunk.js";
};